/**
 * incidentCategoriesUi.js — client adapters for incident-category validation + diff.
 */
import {
  validateConfigValue,
  diffConfig,
  INCIDENT_CATEGORIES_KEY,
} from '@shared/configSchema.js';
import { normalizeCategoryTree } from '@shared/incidentCategoryCascade.js';

export const CONFIG_KEY = INCIDENT_CATEGORIES_KEY;

export function buildContext(treatmentTypes, severityCodes) {
  return { treatmentTypes: treatmentTypes || [], severityCodes: severityCodes || [] };
}

export function validateIncidentCategories(tree, treatmentTypes, severityCodes) {
  return validateConfigValue(CONFIG_KEY, tree, buildContext(treatmentTypes, severityCodes));
}

export function diffIncidentCategories(oldTree, newTree, treatmentTypes, severityCodes) {
  const ctx = buildContext(treatmentTypes, severityCodes);
  const d = diffConfig(CONFIG_KEY, oldTree, newTree, ctx);
  const changed = d.cells?.changed || [];
  return {
    changed,
    hasChanges: changed.length > 0,
  };
}

export function prepareForPublish(tree, treatmentTypes) {
  return normalizeCategoryTree(tree, treatmentTypes);
}

export function summarizeIncidentAuditDiff(diff) {
  const changed = diff?.cells?.changed || [];
  if (changed.length === 0) return 'no field changes';
  return `${changed.length} cell${changed.length === 1 ? '' : 's'} edited`;
}
